export default __webpack_public_path__ + "static/media/willClick.200dab34.png";